import { Check } from "@clockwise/design-system/icons";
import React from "react";

export const CheckoutItem = ({ children }: { children: React.ReactNode }) => (
  <div className="cw-flex cw-items-center cw-text-14 cw-text-slate-darker cw-gap-2">
    <Check />
    <div>{children}</div>
  </div>
);
